import { fireCustomEvent } from '../utils/fireCustomEvent';
export const CALLING_CONNECTION_STATUS_UPDATE = 'CALLING_CONNECTION_STATUS_UPDATE';
export const triggerConnectionStatusUpdate = status => {
  fireCustomEvent(CALLING_CONNECTION_STATUS_UPDATE, {
    status
  });
};
export const addConnectionStatusListener = cb => {
  window.addEventListener(CALLING_CONNECTION_STATUS_UPDATE, cb);
};
export const removeConnectionStatusListener = cb => {
  window.removeEventListener(CALLING_CONNECTION_STATUS_UPDATE, cb);
};